import type { WeeklySlot } from './types';
import { minutesToTime } from './calendarSelection';
import { timeToMinutes } from './weeklySlots';

export type CalendarEdit = 'move' | 'start' | 'end';

/** Shift in five-minute steps without rounding an existing precise time or widening an exact slot. */
export function editCalendarSlot(slot: WeeklySlot, mode: CalendarEdit, deltaMinutes: number, weekday = slot.weekday): WeeklySlot {
  const start = timeToMinutes(slot.timeLocal);
  const end = timeToMinutes(slot.endTimeLocal ?? slot.timeLocal);
  const delta = Math.round(deltaMinutes / 5) * 5;
  if (mode === 'move') {
    const nextStart = Math.max(0, Math.min(1439 - (end - start), start + delta));
    return { ...slot, weekday, timeLocal: minutesToTime(nextStart),
      ...(slot.endTimeLocal === undefined ? {} : { endTimeLocal: minutesToTime(nextStart + end - start) }) };
  }
  if (mode === 'start') {
    return { ...slot, timeLocal: minutesToTime(Math.max(0, Math.min(end, start + delta))), endTimeLocal: minutesToTime(end) };
  }
  return { ...slot, endTimeLocal: minutesToTime(Math.max(start, Math.min(1439, end + delta))) };
}
